import { useState } from 'react';
import type { ApiResponse } from 'vopay';
import { api } from '@/services/api.config';

/**
 * Edits a single remaining payment of a VIOScheduledPayments schedule.
 *
 * The legacy /eft/{fund,withdraw}/schedule/edit routes only match EFT funding and
 * withdrawal transaction types, so they cannot edit a schedule sitting on another
 * rail (RTR, Interac). This endpoint keys off the payment's own detail row and is
 * rail-agnostic. Legacy schedules are not in VIOScheduledPayments at all and still
 * have to use the EFT routes.
 */
export default function useEditUpcomingPayment() {
  const [editing, setEditing] = useState(false);

  async function editUpcomingPayment(
    scheduledPaymentDetailsId: string,
    values: { amount?: number; date?: string },
  ): Promise<ApiResponse> {
    try {
      setEditing(true);

      const res = await api.editScheduledUpcomingPayment({
        ScheduledPaymentDetailsID: scheduledPaymentDetailsId,
        ...(values.amount !== undefined ? { Amount: values.amount } : {}),
        ...(values.date ? { Date: values.date } : {}),
      });

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error('Edit upcoming payment failed:', error);
      throw error;
    } finally {
      setEditing(false);
    }
  }

  return { editing, editUpcomingPayment };
}
